// extracted by mini-css-extract-plugin
export default {"search_wrapper":"Search_search_wrapper__J97iI","search_icon":"Search_search_icon__HSfOA"};